import { useEffect, useMemo } from 'react'
import { useQuery } from 'react-query'

import { getFileTypes } from 'api/files'
import { useFilesStore } from 'store/files'
import { DropDownItem } from 'types/components'
import { DATASTATUS } from 'constants/status'

export const useFileTypes = () => {
  const fileTypesModStatus = useFilesStore(
    (state) => state.fileTypesModStatus
  )
  const fileTypesModStatusSet = useFilesStore(
    (state) => state.fileTypesModStatusSet
  )
  const fileTypesModErrors = useFilesStore(
    (state) => state.fileTypesModErrors
  )
  const fileTypesModErrorsSet = useFilesStore(
    (state) => state.fileTypesModErrorsSet
  )
  const fileTypes = useFilesStore((state) => state.fileTypes)
  const fileTypesSet = useFilesStore((state) => state.fileTypesSet)

  const {
    data: dataFileTypes,
    isLoading: isLoadingFileTypes,
    isError: isErrorFileTypes,
  } = useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['useFileTypes'],
    queryFn: async () => {
      try {
        fileTypesModStatusSet('loading')
        const response = await getFileTypes()
        if (response.outcomeCode === DATASTATUS.outcomeCode) throw response
        fileTypesModStatusSet('success')
        return response
      } catch (e) {
        fileTypesModStatusSet('fail')
        fileTypesModErrorsSet(JSON.stringify(e))
      }
    },
  })

  useEffect(() => {
    if (dataFileTypes) fileTypesSet(dataFileTypes.fileTypes)
  }, [dataFileTypes, fileTypesSet])

  const fileTypesOptions: DropDownItem[] = useMemo(() => {
    return fileTypes.map((item) => ({
      label: String(item.fileTypeName),
      value: String(item.fileTypeId),
    }))
  }, [fileTypes])

  return {
    fileTypesOptions,
    fileTypes,
    fileTypesModStatus,
    fileTypesModErrors,
  }
}
